@if (configuration.display && !!currencies && currencies.length > 0) {
<button #button (click)="onButtonClick()" class="currency-selector-button">
    @if (configuration.showSymbolInButton) {
    <span class="selected-currency-char">
        {{ selectedCurrency.char }}
    </span>
    } @if (configuration.showCodeInButton) {
    <span class="selected-currency-code">
        {{ selectedCurrency.code }}
    </span>
    } @if (configuration.showArrowInButton) {
    <span class="selected-currency-dropdown-arrow">
        <fa-icon [icon]="['fas', 'caret-down']"> </fa-icon>
    </span>
    }
</button>
}
<ul #list class="currency-selector-list hide">
    @for (opt of currencies; track opt) {
    <li
        [class.selected]="opt.code === selectedCurrency.code"
        (click)="onOptionClick(opt.code)"
    >
        @if (opt.flag && configuration.showFlagInList) {
        <span class="fi fi-{{ opt.flag }}"> </span>
        } @if (configuration.showSymbolInList) {
        <span class="option-currency-char">
            {{ opt.char }}
        </span>
        } @if (configuration.showCodeInList) {
        <span class="option-currency-code">
            {{ opt.code }}
        </span>
        }
    </li>
    }
</ul>
